module.exports = "<div class=\"panel-toggle panel-color\" ng-class=\"{\n    'toggle-open': $ctrl.isPaneOpen(),\n    'toggle-close': !$ctrl.isPaneOpen(),\n    'panel-color-2': $ctrl.panel === 'constructor'}\"><a ng-show=\"!$ctrl.isPaneOpen()\" title=\"{{:: 'Открыть панель' | gettext }}\" ng-click=\"$ctrl.switchPanel()\"><span class=\"panel-close\">+</span> </a><a ng-show=\"$ctrl.isPaneOpen()\" title=\"{{:: 'Закрыть панель' | gettext }}\" ng-click=\"$ctrl.switchPanel()\"><span class=\"panel-close\">&times;</span></a></div>"


//////////////////
// WEBPACK FOOTER
// ./src/layout/sidebar-toggle.component.html
// module id = 416
// module chunks = 0